import React, {useState, createContext, useContext} from 'react';
import { ulid } from 'ulid';

const ToastsContext = createContext();

export const useToastsContext = () => {
    return useContext(ToastsContext);
};

export default ({children}) => {

    const [toasts, setToasts] = useState([]);

    const removeToast = (id) => {
        setToasts(notifs => {
            // console.log('clearing', id, notifs)
            return notifs.filter(n => n.id !== id)
        });
    }

    const showToast = (id, type, title, message, persistent) => {
        setToasts(notifs => {
            // Find an existing notification with the same title, type and message and increase its count

            const existing = notifs.find(n => n.title === title && n.type === type && n.message === message);
            if (existing) {
                if (existing.count.indexOf(id) === -1) {
                    existing.count.push(id);
                }
                return [
                    Object.assign({}, existing),
                    ...notifs.filter(n => n.id !== existing.id),
                ];
            }

            return [
                ...notifs,
                {id, type, title, message, count: [id], persistent, clear: () => removeToast(id)}
            ];
        });
    }

    const showError = (title, message, persistent = false) => {
        const id = ulid();
        showToast(id, 'danger', title, message, persistent);
    }

    const showWarning = (title, message, persistent = false) => {
        const id = ulid();
        showToast(id, 'warning', title, message, persistent);
    }

    const showSuccess = (title, message, persistent = false) => {
        const id = ulid();
        showToast(id, 'success', title, message, persistent);
    }

    const showInfo = (title, message, persistent = false) => {
        const id = ulid();
        showToast(id, 'info', title, message, persistent);
    }

    window.toasts = {
        showSuccess,
        showError,
        showWarning,
        showInfo,
    };

    const providerValues = {
        showError,
        showWarning,
        showSuccess,
        showInfo,
        toasts,
    };

    return <ToastsContext.Provider value={providerValues}>
        {children}
    </ToastsContext.Provider>
}
